import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as ManageDeviceProfileManager from '../domain/manage-device-profile-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { PromiseType } from '../../types';

export type DeviceProfileChannels = PromiseType<ReturnType<typeof ManageDeviceProfileManager.getDeviceProfileChannels>>;
type ContextState = Data<DeviceProfileChannels>;
const Context = React.createContext<ContextState | null>(null);

function useManageDeviceProfileChannels(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useManageDeviceProfileChannels must be used within a DeviceProfileChannelsProvider');
    }
    return contextState;
}

const DeviceProfileChannelsProvider: React.FC<{ orgId: string; deviceprofileId: string }> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'device-profile-channels-provider',
        id: `${props.orgId}-${props.deviceprofileId}`,
        dataFn: React.useCallback(
            () => ManageDeviceProfileManager.getDeviceProfileChannels(authHelper, props.orgId,props.deviceprofileId),
            [authHelper, props.orgId,props.deviceprofileId]
        ),
    });

    const deviceProfileChannels = dataFromDataset(dataset);

    return <Context.Provider value={deviceProfileChannels}>{props.children}</Context.Provider>;
};

const TestStarfishChildDeviceDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { DeviceProfileChannelsProvider, TestStarfishChildDeviceDataProvider, useManageDeviceProfileChannels };
